module.exports = __webpack_public_path__ + "static/media/questions.edf5b8a0.svg";